import { render } from "./AddDirectoryModal.vue?vue&type=template&id=35495ce8&ts=true"
import script from "./AddDirectoryModal.vue?vue&type=script&lang=ts"
export * from "./AddDirectoryModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__